import React, { Component, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link,Badge,Checkbox, Select,MenuItem,ListItemText, InputLabel, Box, FormControl,OutlinedInput, Container, Grid, Card, CardContent, CardHeader, Divider, Typography, Icon, LinearProgress, linearProgressClasses, CardActions, Button, Chip, CircularProgress, TextField , Radio, Dialog, DialogTitle, CardActionArea} from '@mui/material';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart'
import { Modal } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash'
import FormLabel from '@mui/material/FormLabel'
import { _freedomAxios,_axios } from 'src/plugins/axios';
import { Notify } from 'src/components/common/Notify';
import { styled } from '@mui/material/styles';


export default function PackageCart (){
 //690651 - Test Flow  Basic Extended Health Check-up
 // 690650 - ELDERLY MALE HEATLH CHECK
    let packages = sessionStorage.getItem('selectedPackages');
    let entityIdFromSessionStroage = sessionStorage.getItem('entityId');
    console.log("entityIdFromSessionStroage ==>",entityIdFromSessionStroage);
    packages = JSON.parse(packages);
    const [cartPackages, setCartPackages] = React.useState(packages)
    const [entityRelationId, setEntityRelationID] = React.useState(0);
    const [entityId, setEntityId] = React.useState(entityIdFromSessionStroage);
    const [entityType, setEntityType] = React.useState('');
    const [entityRelationList, setEntityRelationList] = React.useState([]);
    const [erIdStatus, setErIdStatus] = React.useState('');
    const re = {
        "status": 200,
        "message": "creation successfull",
        "result": {
            "pacakgesCreated": [],
            "noPackageInDB": [],
            "packageAndER_IdExists": [
                {
                    "PER_PM_Id": 690650,
                    "PER_ER_Id": 419374,
                    "PER_PackageAlias": "Test Flow Elderly Male Health Checkup",
                    "PER_CreatedOn": "2022-02-28T17:06:23.900Z",
                    "PER_CreatedBy": "1234",
                    "PER_IsActive": 1,
                    "PER_ModifiedOn": "2022-02-28T17:06:23.900Z",
                    "PER_ModifiedBy": "1234"
                },
                {
                    "PER_PM_Id": 690651,
                    "PER_ER_Id": 419374,
                    "PER_PackageAlias": "Test Flow  Basic Extended Health Check-up",
                    "PER_CreatedOn": "2022-02-28T17:06:23.900Z",
                    "PER_CreatedBy": "1234",
                    "PER_IsActive": 1,
                    "PER_ModifiedOn": "2022-02-28T17:06:23.900Z",
                    "PER_ModifiedBy": "1234"
                }
            ]
        },
        "isSuccess": true
    }
    const packageNameChange = (modifiedPackageName, index) => {
        console.log(new Date());
            cartPackages[index].prefName = modifiedPackageName;
            setCartPackages(cartPackages);
    }

    const updateCartPacakges = (packageIndex) => {
        let finalPackages =  cartPackages.filter((val,index) => index != packageIndex);
        console.log(finalPackages);
        setCartPackages(finalPackages);
        sessionStorage.setItem('selectedPackages', JSON.stringify(finalPackages));
    }
    
    const entityRelationArray = () => {
        let list = [];
        const body = {
            lookUp: "EntityRelation"
        };
        _freedomAxios.post('corporate/lookup', body)
        .then(response => {
            if(response.data.isSuccess){
                
                list = JSON.parse(response.data.result);
                console.log("values ===>",list);
                setEntityRelationList(list)
            }
        }).catch(error => {
            
        })
    }

    const getErId = () => {
        let payLoad = {
            "entityId" : entityId,
            "contractType" : entityType
         }
         console.log(entityId, entityType);

         _freedomAxios.
         post('corporate/getERId', payLoad)
        .then((response) => {

                if(response.data.isSuccess){
                        let result = response.data.result;
                        if(result.length > 0){
                            setEntityRelationID(result[0].ER_Id);
                            return;
                        }
                        setErIdStatus(result.message);
                        return;
                }
                setErIdStatus(result.message);
                return ; 
         }) 
         .catch((error) => {

         });
    }

    const PackageCard = ({packageId, packageName, prefName,index}) => {
           return (  
            <Card 
            key = {index}
            sx = {{minWidth: '3vw', m : '1%', border:'2%'}}
          >
              <CardContent>
              <TextField sx = {{margin : '1%'}}
                disabled
                id="outlined-disabled"
                label = "PackageId"
                defaultValue= {packageId}
            />
              <TextField sx = {{margin : '1%', width: '30%'}} 
                 disabled
                 id="outlined-disabled"
                 label="Package Name"
                 defaultValue= {packageName}
            />
            
            <TextField sx = {{margin : '1%', width: '30%'}} 
                 id="outlined-helperText"
                 label="Prefered Pacakge Name"
                 defaultValue={prefName}
                 onChange = {(e) => setTimeout(packageNameChange(e.target.value, index), 2000)}
            />
            < Button sx = {{margin : '1%'}} onClick = {(e) => updateCartPacakges(index)} >
              < DeleteRoundedIcon></DeleteRoundedIcon>
            </Button>
            </CardContent>
             
             
            </Card> )
    }

    const createPackages = () => {

        let payLoad = {}
        const packageList = cartPackages.map((val,index) => { return ({ packageId: val.packageId, packageName: val.prefName }) })
        payLoad.packageList = packageList;
        payLoad.ER_Id = entityRelationId;
        _freedomAxios
        .post('corporate/createPackage',payLoad)
        .then((response) => {
                if(response.data.isSuccess){
                    result = response.data.result;
                }
        })
        .catch((error) => {
            console.log(error);
            alert(error.response.data.message);
            
        })
    }

    useEffect(() => {
        packages.forEach((pack) => pack.prefName = pack.packageName);
        entityRelationArray();
    }, []);
    

    return (
        <>
        {<Modal
            open={entityRelationId == 0}
            onClose={entityRelationId != 0}
            style={{display:'flex',alignItems:'center',justifyContent:'center', minWidth: '200px', maxHeight:'800px'}}
            >
            <Box>
                <Card>
                    <CardContent>
                        <TextField sx = {{margin : '1%'}}
                            id="outlined-helperText"
                            label = "Entity-Id"
                            type="number"
                            required
                            defaultValue={entityId}
                            onChange = {(e) => setEntityId(e.target.value)}
                        />
                         <Select sx={{ m: 1, minWidth: 120 }}
                         required = {true}
                        value={entityType}
                        onChange={(ev) => { setEntityType(ev.target.value) }}
                        renderValue={(selected) => selected}
                        label="Entity Type"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        >
                            {
                        entityRelationList.map((val, idx) => (
                            <MenuItem sx={{ py: 0 }} value={val.Id} key={idx}>
                                <ListItemText primary={val.entity} />
                            </MenuItem>
                        ))
                        }
                        </Select>
                             <Button variant="contained" sx = {{m: 1}}
                                disabled={entityType == 0 || entityId == 0} 
                                onClick = {(e) => getErId() }
                             >
                                Get ER_ID
                            </Button> 
                            {erIdStatus ? <div>
                                {erIdStatus}  
                            </div> : <></>}
                </CardContent>
                </Card>
            </Box>
        </Modal>}
        {entityRelationId != 0 && <Grid conatiner sx = {2} >
            <Grid item >
            <Card key = {entityRelationId}
            sx = {{minWidth: '3vw', m : '1%', border:'2%'}}
          >
              <CardContent>
              <TextField sx = {{margin : '1%'}}
                disabled
                id="outlined-disabled"
                label = "EntityRelationId"
                defaultValue= {entityRelationId}
            />
              <TextField sx = {{margin : '1%', width: '30%'}} 
                 disabled
                 id="outlined-disabled"
                 label="Contract Type"
                 defaultValue= {entityType}
            />
            <Button variant="contained" sx = {{margin : '1%', width: '30%'}}  onClick = {(e) => createPackages()}>
                Create Packages
            </Button>
            </CardContent>
            </Card>
            </Grid>
           { cartPackages.map((val, index) => (<PackageCard packageId = {val.packageId} packageName = {val.packageName} prefName = {val.prefName} index = {index} />))}
        </Grid>}
        </>
    )
}